<template>
  <div class="row">
    <div class="col-md-4 reports-tab-container">
      <div class="row report-fields-container">
        <div class="col-md-6 report-field-container">
          <label class="report-label">{{ $t('data_exports.invoices.from_date') }}</label>
          <base-date-picker
            v-model="formData.from_date"
            :invalid="$v.formData.from_date.$error"
            :calendar-button="true"
            calendar-button-icon="calendar"
            @change="$v.formData.from_date.$touch()"
            @input="setRangeToCustom"
          />
          <span v-if="$v.formData.from_date.$error && !$v.formData.from_date.required" class="text-danger"> {{ $t('validation.required') }} </span>
        </div>
      </div>
      <div class="row report-submit-button-container">
        <div class="col-md-6">
          <base-button outline color="theme" class="report-button" @click="getReports()">
            {{ $t('data_exports.update_data') }}
          </base-button>
        </div>
      </div>
    </div>
    <div class="col-sm-8 reports-tab-container">
      <iframe :src="getReportUrl" class="reports-frame-style"/>
      <a class="base-button btn btn-primary btn-lg report-view-button" @click="viewReportsPDF">
        <font-awesome-icon icon="file-pdf" class="vue-icon icon-left svg-inline--fa fa-download fa-w-16 mr-2" /> <span>{{ $t('data_exports.view_pdf') }}</span>
      </a>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import { validationMixin } from 'vuelidate'
const { required } = require('vuelidate/lib/validators')

export default {
  mixins: [validationMixin],
  data () {
    return {
      hidefields: '',
      reportTypes: ['By Customer', 'By Item'],
      selectedType: 'By Customer',
      FilterReport: ["Invoice Date", "Invoice Due Date", "Buyer Name", "Supplier Name", 'Status','System-generated Invoice No.','Amount', 'Promised Payment Date',"Offer Amount", "Prepayment"
        ,"Supplier Contact No.","Supplier Address","Supplier National Tax Registration Number","Invoice Reference No.",
        "System-generated DN","Delivery Note Date","National Tax Registration Number",
        "Sales Tax Registration Number","System-generated PO","Payment Term","Purchase Order Date","PO Reference Number",
        "Delivery Note Information","Billing Address","Shipping Address","Notes","Vendor Number","Tax Amount", "Discrepancy", "Payment Amount", "Actual Amount", "Check Number", "Date of Prepayment", "Received Invoice Date"]
      ,
      range: new Date(),
      formData: {
        from_date: moment().startOf('month').toString(),
        to_date: moment().endOf('month').toString(),
        customer_id: '',
        user: '',
        viewcolumns: ["Invoice Date", "Invoice Due Date", "Buyer Name", "Supplier Name",'Status','Invoice Number','Amount', 'Promised Payment Date',"Offer Amount", "Prepayment"]
      },
      url: null,
      customerSiteURL: null,
      userType: null
    }
  },
  validations: {
    range: {
      required
    },
    formData: {
      from_date: {
        required
      }
      // ,
      // to_date: {
      //   required
      // }
    }
  },
  computed: {
    ...mapGetters('company', [
      'getSelectedCompany'
    ]),

    ...mapGetters('supplier', [
      'suppliers'
    ]),
    getReportUrl () {
      return this.url
    }
  },
  watch: {
    range (newRange) {
      this.formData.from_date = moment(newRange).startOf('year').toString()
      // this.formData.to_date = moment(newRange).endOf('year').toString()
    }
  },
  created () {
    let data = {pagination: 'no'}
    if (localStorage.getItem('role') === 'super_admin') {
      this.userType = 'super_admin'
    } else if (localStorage.getItem('account_type') === 'anchor') {
      this.userType = 'anchor'
      this.fetchSuppliers(data)
    } else if (localStorage.getItem('account_type') === 'funder') {
      this.userType = 'funder'
    } else if (localStorage.getItem('account_type') === 'supplier') {
      this.userType = 'supplier'
    }
  },
  mounted () {
    this.customerSiteURL = `/data-exports/invoices-detail/customer/${this.getSelectedCompany.unique_hash}`

    this.getInitialReport()
  },
  methods: {
    ...mapActions('supplier', [
      'fetchSuppliers'
    ]),
    getThisDate (type, time) {
      return moment()[type](time).toString()
    },
    getPreDate (type, time) {
      return moment().subtract(1, time)[type](time).toString()
    },
    setRangeToCustom () {
      this.selectedRange = 'Custom'
    },
    async getInitialReport () {
      if (this.selectedType === 'By Customer') {
        if ( this.userType === 'supplier') {
          this.url = `${this.customerSiteURL}?customer_id=${this.formData.customer_id}&columns=${this.formData.viewcolumns}&from_date=${moment(this.formData.from_date).format('DD/MM/YYYY')}&to_date=${moment(this.formData.to_date).format('DD/MM/YYYY')}`
        } else if (this.userType === 'funder') {
          this.url = `${this.customerSiteURL}?user_id=${this.formData.customer_id}&columns=${this.formData.viewcolumns}&from_date=${moment(this.formData.from_date).format('DD/MM/YYYY')}&to_date=${moment(this.formData.to_date).format('DD/MM/YYYY')}&funder_report=true`
        } else if (this.userType === 'anchor') {
          this.url = `${this.customerSiteURL}?company_id=${this.formData.user === '' ? this.formData.user : this.formData.user.company_id}&columns=${this.formData.viewcolumns}&from_date=${moment(this.formData.from_date).format('DD/MM/YYYY')}&to_date=${moment(this.formData.to_date).format('DD/MM/YYYY')}`
        }

        return true
      }
      return true
    },
    async viewReportsPDF () {
      let data = await this.getReports()
      window.open(this.getReportUrl, '_blank')
      return data
    },
    async getReports (isDownload = false) {
      this.$v.range.$touch()
      this.$v.formData.$touch()
      if (this.$v.$invalid) {
        return true
      }

      await this.filterColumns()

      if (this.selectedType === 'By Customer') {
        if (this.userType === 'supplier') {
          this.url = `${this.customerSiteURL}?customer_id=${this.formData.customer_id}&columns=${this.formData.viewcolumns}&from_date=${moment(this.formData.from_date).format('DD/MM/YYYY')}&to_date=${moment(this.formData.to_date).format('DD/MM/YYYY')}`
        } else if (this.userType === 'funder') {
          this.url = `${this.customerSiteURL}?user_id=${this.formData.customer_id}&columns=${this.formData.viewcolumns}&from_date=${moment(this.formData.from_date).format('DD/MM/YYYY')}&funder_report=true`
        } else if (this.userType === 'anchor') {
          this.url = `${this.customerSiteURL}?company_id=${this.formData.user === '' ? this.formData.user : this.formData.user.company_id}&columns=${this.formData.viewcolumns}&from_date=${moment(this.formData.from_date).format('DD/MM/YYYY')}&to_date=${moment(this.formData.to_date).format('DD/MM/YYYY')}`
        }
        return true
      }

      return true
    },
    async downloadReport () {
      if (!this.getReports()) {
        return false
      }
      await this.filterColumns()
      window.open(this.getReportUrl + '&download=true')
      setTimeout(() => {
        if (this.selectedType === 'By Customer') {
          if (this.userType === 'supplier') {
            this.url = `${this.customerSiteURL}?customer_id=${this.formData.customer_id}&columns=${this.formData.viewcolumns}&from_date=${moment(this.formData.from_date).format('DD/MM/YYYY')}&to_date=${moment(this.formData.to_date).format('DD/MM/YYYY')}`
          } else if (this.userType === 'funder') {
            this.url = `${this.customerSiteURL}?user_id=${this.formData.customer_id}&columns=${this.formData.viewcolumns}&from_date=${moment(this.formData.from_date).format('DD/MM/YYYY')}&to_date=${moment(this.formData.to_date).format('DD/MM/YYYY')}`
          } else if (this.userType === 'anchor') {
            this.url = `${this.customerSiteURL}?user_id=${this.formData.user === '' ? this.formData.user : this.formData.user.company_id}&columns=${this.formData.viewcolumns}&from_date=${moment(this.formData.from_date).format('DD/MM/YYYY')}&to_date=${moment(this.formData.to_date).format('DD/MM/YYYY')}`
          }
          return true
        }
        return true
      }, 200)
    },
    filterColumns (){
      var result =[];
      var selectedColumns = this.formData.viewcolumns;
      this.formData.viewcolumns = this.FilterReport.filter(item => selectedColumns.includes(item));
    },
    onSelectCustomer (customer) {
      this.formData.customer_id = customer.id
    },
    async clearCustomerSearch (removedOption, id) {
      this.formData.customer_id = ''
    }
  }
}
</script>
